import React, { useState, useEffect, useRef } from "react";
import ArrowDown from "../../images/svg/ArrowDown.svg"
import SelectOption from "./SelectOption";


const Selectbox = (props) => {

  const { data, onSelect, containerClass = "", multiselect, placeholder, defaultValue = [], checkbox = false, labelClass, optionClass, SelectClass = "" } = props;

  const [open, setOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const selectBoxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectBoxRef.current &&
        !selectBoxRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectBoxRef]);

  useEffect(() => {
    setSelectedValues(defaultValue);
  }, []);

  const handleSelect = (item) => {
    let updatedValues;
    if (multiselect) {
      if (selectedValues?.some((selected) => selected.value === item.value)) {
        updatedValues = selectedValues?.filter(
          (selected) => selected.value !== item.value
        );
      } else {
        updatedValues = [...selectedValues, item];
      }
    } else {
      updatedValues = [item];
      setOpen(false);
    }

    setSelectedValues(updatedValues);
    if (onSelect) {
      onSelect(updatedValues);
    }
  };

  useEffect(() => {
    setSelectedValues((prev) => prev)
  }, [selectedValues])

  return (
    <div onClick={() => setOpen(!open)} ref={selectBoxRef} className={`relative ${containerClass}`}>
      <div
        onClick={() => setOpen(!open)}
        className={`h-[45px] w-full rounded-[5px] bg-SelectBg border border-SelectBorder flex items-center justify-between px-2 cursor-pointer ${SelectClass}`}
      >
        <div
          className={`flex items-center flex-grow gap-2 min-w-0 ${selectedValues[0]?.prefix ? "gap-3" : ""}`}
          onClick={() => setOpen(!open)}
        >
          {multiselect && selectedValues.length > 0 && (
            <div className="min-w-[30px] h-[30px] flex items-center justify-center rounded-full bg-[#4DB748] text-white font-medium flex-shrink-0">
              {selectedValues.length}
            </div>
          )}
          {!multiselect && selectedValues[0]?.prefix && (
            <div className="flex-shrink-0">{selectedValues[0]?.prefix}</div>
          )}

          <h4 className="truncate font-medium text-[16px] m-0 flex-grow">
            {selectedValues.length > 0 ? (
              <span className="text-black font-medium truncate block">
                {selectedValues[0]?.label}
              </span>
            ) : (
              <span className="text-[#000000] opacity-[0.4]">
                {placeholder ? placeholder : "Select Notification Type"}
              </span>
            )}
          </h4>
        </div>
        <div className="flex-shrink-0 ml-2" onClick={() => setOpen(!open)}>
          <img
            src={ArrowDown}
            className={`${open ? "rotate-180" : "rotate-0"} transition-all duration-300 ease-in-out w-[10px] h-[10px]`}
          />
        </div>
      </div>
      <div
        className={`absolute top-[105%] w-full transition-all duration-300 ease-in-out transform  ${open
            ? "scale-100 opacity-100 translate-y-[0px] !z-[10] pointer-events-auto"
            : "scale-95 opacity-0 translate-y-[-20px] pointer-events-none"
          }`}
        style={{ zIndex: 1 }}
      >
        <ul
          className={`shadow-SelectShadow max-h-[220px] bg-white flex flex-col gap-[3px] rounded m-0 p-0 overflow-y-auto ${open ? " pointer-events-auto" : " pointer-events-none"
            }`}
        >
          {selectedValues.map((item, index) => {
            const propesData = { item, index, multiselect, selectedValues, labelClass, isSelected: true, handleSelect, optionClass, checkbox }
            return (<SelectOption {...propesData} />
            );
          })
          }
          {data.map((item, index) => {
            const isSelected = selectedValues?.some(
              (selected) => selected.value === item.value
            );
            const propesData = { item, index, multiselect, selectedValues, labelClass, isSelected, handleSelect, optionClass, checkbox, allOption: true }
            return (<SelectOption {...propesData} />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Selectbox;
